import {collectDeviceInfo} from './deviceInfo';
import {
  v2NotifyLoginLockout,
  type V2LoginLockoutRequest,
} from './v2/api';

export function buildLoginLockoutPayload(
  login: string,
  device: Omit<V2LoginLockoutRequest, 'login'>,
): V2LoginLockoutRequest {
  return {login, ...device};
}

/** Send the last submitted login and non-secret device metadata to backend. */
export async function reportLoginLockout(login: string): Promise<void> {
  const device = await collectDeviceInfo();
  await v2NotifyLoginLockout(buildLoginLockoutPayload(login, device));
}
